import { render, staticRenderFns } from "./SearchPanelResults.vue?vue&type=template&id=7bf928a0"
import script from "./SearchPanelResults.vue?vue&type=script&lang=js"
export * from "./SearchPanelResults.vue?vue&type=script&lang=js"
import style0 from "./SearchPanelResults.vue?vue&type=style&index=0&id=7bf928a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports